// THIS FILE IS GENERATED. ANY CHANGES TO THIS FILE WILL BE LOST.
import type { TOC } from '@ember/component/template-only';

export interface PowerButtonIconSignature {
  Element: SVGSVGElement;
}

export const PowerButtonIcon: TOC<PowerButtonIconSignature> = <template><svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" ...attributes>
<path fill-rule="evenodd" clip-rule="evenodd" d="M13 3H11V11H13V3ZM15 7.812V5.589C17.928 6.779 20 9.65 20 13C20 17.411 16.411 21 12 21C7.589 21 4 17.411 4 13C4 9.65 6.072 6.779 9 5.589V7.812C7.209 8.852 6 10.785 6 13C6 16.309 8.691 19 12 19C15.309 19 18 16.309 18 13C18 10.786 16.791 8.852 15 7.812Z"/>
</svg>
</template>;